import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'Jump back not allowed on question 3'
 */
export class SaltoNoPermitidoParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Jump back not allowed on question");
    }

    public traducir(error: string): string {
        const matches = error.match(/\d+/g);
        if (matches == null || matches.length === 0) {
            return "";
        }
        return `Salto no permitido en la pregunta ${matches[0]}`;
    }
}
